<template>
    <v-list
        ><v-list-item v-for="item in items" :key="item.value">
            <SoliBtn
                block
                @click="$emit('input', item)"
                :text="item.name"
                color="soli-grey"
                outlined
                class="my-1"
            ></SoliBtn> </v-list-item
    ></v-list>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {};
    },
};
</script>

<style></style>
